<template>
  <div>
    <label>{{filterElement.label_title || "Unconfigured Filter"}}</label>
    <p><a :href="path" class="btn-link">Configure Filter</a></p>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import filterElementBaseMixin from "../../../common/mixins/listViews/filterElementBaseMixin"
  import {RouteHelper} from "../../../common/helpers/routeHelper"
  import {Route} from "../../../common/enums/route";

  export default Vue.extend({
    mixins: [
      filterElementBaseMixin,
    ],
    data: function () {
      return {};
    },
    computed: {
      path(): string {
        return RouteHelper.path({route: Route.editListViewFilters, modelOrId: this.filterElement.listView}) + `?selectedId=${this.filterElement.client_id}`
      }
    },
  });
</script>
